import React from "react";
import { styled } from "@mui/material/styles";
import {
    Box,
    InternalStandardProps,
    LinearProgress,
} from "@mui/material";
import { AppTypography } from "./AppTypography";
import { AppCircularProgress } from "./Progress/AppCircularProgress";

const StyledRoot = styled("div")({});

const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
    background: theme.palette.grey[300],
    "& .MuiLinearProgress-bar": {
        backgroundColor: theme.palette.grey[500],
    },
}));

interface StyledCompletionTextProps {
    isDownloadingQueue?: boolean;
}

const StyledCompletionText = styled(AppTypography, {
    shouldForwardProp: (prop) => prop !== "isDownloadingQueue",
})<StyledCompletionTextProps>(({ theme, isDownloadingQueue }) => ({
    color: theme.palette.grey[600],
    textAlign: "center",
    fontWeight: 500,
    marginBottom: theme.spacing(0.5),
    ...(isDownloadingQueue && {
        height: "25px",
    }),
}));

export interface AppCompletionProgressProps
    extends InternalStandardProps<
        React.DetailedHTMLProps<
            React.HTMLAttributes<HTMLDivElement>,
            HTMLDivElement
        >
    > {
    title: string;
    loading?: boolean;
    value?: number;
    lowerTitle?: string;
    isDownloadingQueue?: boolean;
}

export const AppCompletionProgress = (props: AppCompletionProgressProps) => {
    const {
        className,
        title,
        lowerTitle,
        isDownloadingQueue,
        loading,
        value,
        ...rest
    } = props;

    return (
        <StyledRoot {...rest} className={className}>
            {!loading && (
                <>
                    <StyledCompletionText
                        isDownloadingQueue={isDownloadingQueue}
                        variant="body1"
                    >
                        {title}
                    </StyledCompletionText>
                    <StyledLinearProgress
                        variant="determinate"
                        value={value}
                    />
                    <StyledCompletionText
                        isDownloadingQueue={isDownloadingQueue}
                        variant="body1"
                    >
                        {lowerTitle}
                    </StyledCompletionText>
                </>
            )}
            {loading && (
                <Box display={"flex"} justifyContent="center">
                    <AppCircularProgress loaderSize={"small"} />
                </Box>
            )}
        </StyledRoot>
    );
};
